module.exports = __webpack_public_path__ + "static/media/4 POINT 9 TONEARM.f1d6a3b3.png";